import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class ContractCallbackService {
    constructor(
        private _baseWebService: BaseWebService
    ){}

    // sends docusign auth code
    sendDocuSignAuth = (code: any, id: any): Observable<any> => {
        const data: any = {};
        data.body = code;
        return this._baseWebService.request("v1/docusign_contract_complete/?id=" + id , "get")
            .map((res: any) => res)
            .catch(this.handleError);

    }

    /**
     * function for login error.
     * @param  {Response|any} error error response.
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}